module.exports = __webpack_public_path__ + "img/resourcesbg2.869051ff.png";